import React from 'react';
import ReactDOM from 'react-dom';
import InfiniteScroll from '../InfiniteScroll';
import SmallPost from '../Models/SmallPost';

class TagPage extends React.Component {
  constructor(props) {
    super(props);

    this.state =  {
      pagetype: '',
      endpoint: `tag/${window.tag.id}`,
      urlStructure: '%domain%/etikett/%tagSlug%/page/%id%/',
    };
  }

  componentDidMount() {
    this.getInitialState();
  }

  getInitialState() {
    this.setState(() => ({  
      pagetype: 'tag',
    }));
  }
  
  getSeoDataArray(post) {
    let seoDataArray = [];

    if (!post) {
      return seoDataArray;
    }

    seoDataArray['aller_ga'] = window.aller_ga ?? {};
    
    return seoDataArray;
  }

  render() {
    return (
      <InfiniteScroll 
        pageId={this.props.pageId}
        urlStructure={this.state.urlStructure}
        perPage={20}
        endpoint={this.state.endpoint}
        pagetype={this.state.pagetype}
        getSeoDataArray={this.getSeoDataArray}
        >
        <SmallPost />
      </InfiniteScroll>
    )
  } 

}
const tagPageElement = document.getElementById('tag');
if (tagPageElement) {
  ReactDOM.render(<TagPage pageId={tagPageElement.dataset.pageid}/>, tagPageElement);
}